import React, { useCallback, useEffect, useState, lazy } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const images = ['https://cdn.magicpatterns.com/uploads/8UjAeZqqXBh95RuNGWLAZw/hf_20260215_193849_ae29da28-47be-46f4-8b53-75a6bc2e7e08.png', 'https://cdn.magicpatterns.com/uploads/hSru39wKqE3njSarvSyYrx/hf_20260215_193909_ae93dcf3-5046-4c42-bcf6-4156cc107cae.png', 'https://cdn.magicpatterns.com/uploads/5BopLcCWc21VK2Z4NUvo6w/hf_20260215_194254_f80b9f9e-e50e-4464-bc99-9de9998bc759.png', 'https://cdn.magicpatterns.com/uploads/gspVd2bMbXzPLH9qJt9Bzr/hf_20260215_194308_b4a15a89-4b90-46eb-8c02-418d5bb761c1.png', 'https://cdn.magicpatterns.com/uploads/wns9deFBtuGnGwTXWLFBWp/hf_20260215_194322_cfef81fa-5b6f-4f02-9c9b-7b21223abc5d.png'];
export function WhatsAppCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const paginate = useCallback((newDirection: number) => {
    setCurrentIndex(prevIndex => {
      let nextIndex = prevIndex + newDirection;
      if (nextIndex < 0) nextIndex = images.length - 1;
      if (nextIndex >= images.length) nextIndex = 0;
      return nextIndex;
    });
  }, []);
  // Auto-advance
  useEffect(() => {
    const timer = setInterval(() => {
      paginate(1);
    }, 5000);
    return () => clearInterval(timer);
  }, [paginate]);
  return <div className="relative w-full max-w-sm mx-auto my-8 bg-black/20 rounded-3xl overflow-hidden border-4 border-[#25D366]/30 shadow-[0_0_30px_rgba(37,211,102,0.15)]" style={{
    height: '500px'
  }} data-id="element-397">
      {/* Stable image container — no AnimatePresence, just CSS transition */}
      <div className="absolute inset-0" data-id="element-398">
        {images.map((src, index) => <img key={index} src={src} alt={`Testimonio de WhatsApp ${index + 1}`} className="absolute inset-0 w-full h-full object-cover" style={{
        opacity: index === currentIndex ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out',
        willChange: index === currentIndex ? 'opacity' : 'auto'
      }} width={400} height={700} loading={index === 0 ? 'eager' : 'lazy'} decoding={index === 0 ? 'sync' : 'async'} data-id="element-399" />)}
      </div>

      {/* Navigation Buttons */}
      <div className="absolute inset-0 flex items-center justify-between px-2 pointer-events-none z-10" data-id="element-400">
        <button className="p-2 rounded-full bg-black/50 text-white hover:bg-black/70 transition-colors pointer-events-auto backdrop-blur-sm" onClick={() => paginate(-1)} aria-label="Anterior testimonio" data-id="element-401">
          <ChevronLeft className="w-6 h-6" data-id="element-402" />
        </button>
        <button className="p-2 rounded-full bg-black/50 text-white hover:bg-black/70 transition-colors pointer-events-auto backdrop-blur-sm" onClick={() => paginate(1)} aria-label="Siguiente testimonio" data-id="element-403">
          <ChevronRight className="w-6 h-6" data-id="element-404" />
        </button>
      </div>

      {/* Indicators */}
      <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-2 z-10" data-id="element-405">
        {images.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-2.5 rounded-full transition-all shadow-sm ${index === currentIndex ? 'bg-[#25D366] w-6' : 'bg-white/50 hover:bg-white/80 w-2.5'}`} aria-label={`Ir a testimonio ${index + 1}`} data-id="element-406" />)}
      </div>
    </div>;
}